import type { ArdoqId } from '@ardoq/api-types';
import { AppModules } from 'appContainer/types';
import { param } from 'router/declarative/paramRegistry';
import { PathRouteContent, RouteNode } from 'router/declarative/routeNode';

const ardoqIdParam = param<ArdoqId>({
  fromString: value => value,
  toString: value => value,
});

const showNavigatorParam = param<boolean>({
  fromString: value => value === 'true',
  toString: value => String(value),
});

export const routes = {
  path: '/component-overview',
  title: 'Component Overview',
  appModule: AppModules.COMPONENT_OVERVIEW_PAGE,
  children: [
    {
      path: '/:componentId',
      searchParams: {
        surveyId: ardoqIdParam,
        broadcastInstanceId: ardoqIdParam,
        showNavigator: showNavigatorParam,
      },
      content: async (): PathRouteContent =>
        (await import('./ComponentOverviewPage')).ComponentOverviewPage,
    },
  ],
} as const satisfies RouteNode;
